import { useEffect } from 'react';

/**
 * 웹뷰에서 버튼과 링크가 실수로 연속으로 클릭되는 것을 방지하는 훅
 */
export const useButtonClickGuard = () => {
    useEffect(() => {
        const CLICK_THRESHOLD = 400; // 중복 클릭 방지 시간 (ms)
        let buttonLastClickedAt = 0; // 버튼의 마지막 클릭 시간

        const onButtonClickOnCapture = (e: MouseEvent) => {
            const target = e.target as HTMLElement;

            const elButton = target.closest('button, a, [role="button"]');
            if (!elButton) {
                return;
            }

            // 키보드 활성화는 통과(detail === 0 이면 보통 키보드)
            if (typeof e.detail === 'number' && e.detail === 0) {
                return;
            }

            const now = Date.now();

            // 마지막 버튼 클릭 후 CLICK_THRESHOLD 이내에는 모든 버튼 클릭 차단
            if (buttonLastClickedAt && now - buttonLastClickedAt < CLICK_THRESHOLD) {
                e.stopImmediatePropagation();
                e.preventDefault();
                return;
            }

            // 클릭 허용 시 전역 시간 업데이트
            buttonLastClickedAt = now;
        };

        document.addEventListener('click', onButtonClickOnCapture, true);

        // 클린업 함수 반환
        return () => {
            document.removeEventListener('click', onButtonClickOnCapture, true);
        };
    }, []);
};
